import React, { memo } from "react";
import Markdown from "react-markdown";
import { userAgreement } from "@/pages/Index/doc/content";



interface Props {
}

const Privacy: React.FC<Props> = memo(() => {

  return (
    <div className={"p-10 overflow-auto"}>
      <Markdown>
        {userAgreement}
      </Markdown>
    </div>
  );
});

export default Privacy;
